import * as React from "react";

import { Colors, Icon } from "@blueprintjs/core";
import { css } from "glamor";
import { arrayMove, SortableContainer, SortableElement } from "react-sortable-hoc";

import { Jurors } from "../Interfaces";

const styles = {
	container: css({
		margin: "0 20px",
	}),
	element: css({
		margin: "7px",
		width: "100%",
		height: "20px",
		textAlign: "left",
		display: "flex",
		":hover": {
			background: Colors.LIGHT_GRAY3,
			cursor: "grab",
		},
	}),
	icon: css({
		marginRight: "5px",
	}),
};

const SortableItem = SortableElement(({ value }: { value: string }) => (
	<div {...styles.element}>
		<Icon icon="menu" iconSize={20} {...styles.icon} />
		<div>{value}</div>
	</div>
));

export default class JurorArranger extends React.Component<
	{
		disableArranging: boolean;
		jurors: Jurors;
		onRearrange: (jurorIDs: number[]) => void;
	},
	{ jurors: Jurors }
> {
	private SortableList = SortableContainer(({ items }: { items: Jurors }) => {
		return (
			<div {...styles.container}>
				{Object.keys(items)
					.map((key) => items[key])
					.sort((a, b) => a.position - b.position)
					.map((juror, index) => (
						<SortableItem
							key={`item-${index}`}
							index={index}
							value={juror.firstname + " " + juror.lastname}
							disabled={this.props.disableArranging}
						/>
					))}
			</div>
		);
	});
	private onSortEnd = ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }) => {
		this.props.onRearrange(
			arrayMove(
				Object.keys(this.props.jurors)
					.map((key) => this.props.jurors[key])
					.sort((a, b) => a.position - b.position),
				oldIndex,
				newIndex
			).map((juror) => juror.id)
		);
	};

	public render() {
		return (
			<this.SortableList
				lockAxis={"y"}
				lockToContainerEdges={true}
				items={this.props.jurors}
				onSortEnd={this.onSortEnd}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/FightRoom/JurorArranger.tsx